export class BackupPolicyConfigResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "attachedResources",
            "baseName": "attachedResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "processing",
            "baseName": "processing",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "condition",
            "baseName": "condition",
            "type": "Condition",
            "format": ""
        },
        {
            "name": "include",
            "baseName": "include",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "exclude",
            "baseName": "exclude",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "schedules",
            "baseName": "schedules",
            "type": "Array<BackupSchedule>",
            "format": ""
        },
        {
            "name": "isSecurityScanEnabled",
            "baseName": "isSecurityScanEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "dateCreated",
            "baseName": "dateCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "policyType",
            "baseName": "policyType",
            "type": "BackupPolicyType",
            "format": ""
        },
        {
            "name": "scheduleMode",
            "baseName": "scheduleMode",
            "type": "ScheduleMode",
            "format": ""
        },
        {
            "name": "scheduleTimezone",
            "baseName": "scheduleTimezone",
            "type": "ScheduleTimezone",
            "format": ""
        },
        {
            "name": "classificationSchedule",
            "baseName": "classificationSchedule",
            "type": "ClassificationScheduleConfig",
            "format": ""
        },
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<ResourceType>",
            "format": ""
        },
        {
            "name": "vaultStorageTier",
            "baseName": "vaultStorageTier",
            "type": "VaultStorageTier",
            "format": ""
        },
        {
            "name": "awsNativePitrConfig",
            "baseName": "awsNativePitrConfig",
            "type": "AwsNativePitrConfig",
            "format": ""
        },
        {
            "name": "bigQueryNativePitrConfig",
            "baseName": "bigQueryNativePitrConfig",
            "type": "BigQueryNativePitrConfig",
            "format": ""
        },
        {
            "name": "azureSqlDatabaseNativePitrConfig",
            "baseName": "azureSqlDatabaseNativePitrConfig",
            "type": "AzureSqlDatabaseNativePitrConfig",
            "format": ""
        },
        {
            "name": "nativeStandardConfig",
            "baseName": "nativeStandardConfig",
            "type": "NativeStandardConfig",
            "format": ""
        },
        {
            "name": "azureFilesConfig",
            "baseName": "azureFilesConfig",
            "type": "AzureFilesBackupPolicyPlan",
            "format": ""
        },
        {
            "name": "microsoft365Config",
            "baseName": "microsoft365Config",
            "type": "Microsoft365PolicyConfig",
            "format": ""
        },
        {
            "name": "azureEntraIdConfig",
            "baseName": "azureEntraIdConfig",
            "type": "AzureEntraIdPolicyConfig",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPolicyConfigResponse.attributeTypeMap;
    }
    constructor() {
    }
}
